import { render, staticRenderFns } from "./PaymentBillEfectyBalotoAnonymo.vue?vue&type=template&id=067c892a&"
import script from "./PaymentBillEfectyBalotoAnonymo.vue?vue&type=script&lang=js&"
export * from "./PaymentBillEfectyBalotoAnonymo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports